import type { ReactElement } from 'react'

import { Popover } from '../../Popover'
import { useTranslate } from '../../../utils/translate'

type ImageUploadOptionsPopoverProps = {
  readonly isOpen: boolean
  readonly onOpenChange: (open: boolean) => void
  readonly onUnsplashClick: () => void
  readonly onUploadClick: () => void
  readonly trigger: ReactElement
  readonly className?: string
  readonly side?: 'top' | 'bottom' | 'left' | 'right'
  readonly sideOffset?: number
  readonly zIndex?: number
}

export function ImageUploadOptionsPopover({
  isOpen,
  onOpenChange,
  onUnsplashClick,
  onUploadClick,
  trigger,
  className,
  side = 'top',
  sideOffset = 30,
  zIndex = 1,
}: ImageUploadOptionsPopoverProps): ReactElement {
  const t = useTranslate('interface', 'components.imageUploadSelectionComponent.ImageSourceSelectionDropdown')

  return (
    <Popover
      side={side}
      sideOffset={sideOffset}
      avoidCollisions
      open={isOpen}
      onOpenChange={onOpenChange}
      className={className}
      trigger={trigger}
      zIndex={zIndex}
      usePortal
    >
      <button type="button" className="image-upload-option-unsplash" onClick={onUnsplashClick}>
        {t('imageSourceOptions.unsplash')}
      </button>
      <button type="button" className="image-upload-option-upload" onClick={onUploadClick}>
        {t('imageSourceOptions.upload')}
      </button>
    </Popover>
  )
}
